<app-common-modal-form
  header="Annature Login"
  subheader="Please select the account you want to use"
  closeText="Disconnect"
  confirmText="Save"
  icon="ic-mail-20"
  (close)="close()"
  (confirm)="confirm()"
>
  <div class="pb-3">
    <app-select
      label="Annature Accounts"
      placeholder="Select Annature Account"
      [formControl]="pickedAccountIdControl"
      [options]="accountOptions"
      [valuePrimitive]="true"
    />
  </div>
</app-common-modal-form>
